/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useNavigate, useLocation } from "react-router-dom";
import { empty, errorResponse, prepareResponseData } from "../../Utilities/utils";
import { AuthContext } from "../Root/ProtectedRoute";

// css
import "../students/Students.css";

// api
import activityTypeApi from "../../api/Activities";

//components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import { Toast } from "primereact/toast";
import FullPageLoader from "../../components/loader/FullPageLoader";
import TableLoading from "../../components/skeleton/TableLoading";
import { FaPlus } from "react-icons/fa";
import ActivitiesWrapper from "../../components/appWrapper/ActivitiesWrapper";
import ActivitiesTypeTable from "../../components/tables/primeTable/activities/ActivitiesTypeTable";

const ActivityTypes = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  //ref
  const toastTR = useRef(null);
  // states
  const [activityTypes, setActivityTypes] = useState([]);
  const [activityTypeModalVisibility, setActivityTypeModalVisibility] = useState(false);
  const [selectedActivityTypeDetail, setSelectedActivityTypeDetail] =
    useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [modalType, setModalType] = useState("update");

  useEffect(() => {
    // fetch activity type
    try {
      getActivityTypes();

      if (!empty(location) && !empty(location.state)) {
        const paramState = !empty(location.state) ? location.state : {};
        let activityTypeAdded = !empty(paramState.activityTypeAdded)
          ? paramState.activityTypeAdded
          : false;
        let activityTypeUpdated = !empty(paramState.activityTypeUpdated)
          ? paramState.activityTypeUpdated
          : false;
        if (
          activityTypeAdded === true ||
          activityTypeUpdated === true 
        ) {
          const actionType = activityTypeAdded
            ? "added"
            : activityTypeUpdated
            ? "updated"
            : "";
          paramState.activityTypeAdded = false;
          paramState.activityTypeUpdated = false;
          responseDialog(
            "success",
            "Success",
            `Activity type, ${actionType} successfully!`
          );
          if (!empty(location) && !empty(location.state)) {
            navigate(null, {
              replace: true,
              state: {
                activityTypeAdded: false,
                activityTypeUpdated: false,
              },
            });
          }
        }
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    }
  }, []);

  // function to get all activities
  const getActivityTypes = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await activityTypeApi.getActivityTypes(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setActivityTypes([]);
      } else {
        setActivityTypes(response_data.response);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  //alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  // delete activity type
  const deleteActivityType = async () => {
    try {
      if (activityTypeModalVisibility) setActivityTypeModalVisibility(false);
      if (!isActionLoading) setIsActionLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const activityTypeId =
        !empty(selectedActivityTypeDetail) &&
        !empty(selectedActivityTypeDetail._id)
          ? selectedActivityTypeDetail._id
          : "";
      const response = await activityTypeApi.deleteActivityType(schoolId, activityTypeId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        const error_response =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Failed to delete activity";
        return responseDialog("error", "Something went wrong", error_response);
      }

      responseDialog(
        "success",
        "Success",
        `Activity Type, ${
          !empty(selectedActivityTypeDetail.title)
            ? selectedActivityTypeDetail.title
            : ""
        }, was deleted successfully!`
      );
      return getActivityTypes();
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsActionLoading(false);
    }
  };

  //function to hide confirm modal
  const hideActivityModal = () => {
    setActivityTypeModalVisibility(false);
  };

  //go to update activity type page
  const gotToUpdateActivityType = (data) => {
    const activityTypeId = !empty(data) && !empty(data._id) ? data._id : "";
    navigate(`/activity-type/${activityTypeId}/update`);
  };

  // delete activity type
  const showDeleteActivityTypeModal = (data) => {
    setModalType("delete");
    setSelectedActivityTypeDetail(data);
    setActivityTypeModalVisibility(true);
  };

  const activityModalFooter = (
    <div
      style={{
        marginTop: 20,
      }}
    >
      <Button
        label="No"
        icon="pi pi-times"
        style={{
          backgroundColor: "transparent",
          color: "#e65061",
          borderColor: "#e65061",
          borderWidth: 1,
        }}
        onClick={hideActivityModal}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        style={{
          backgroundColor: "transparent",
          color: "#389d17",
          borderColor: "#389d17",
          borderWidth: 1,
        }}
        onClick={() => deleteActivityType()
        }
      />
    </div>
  );

  return (
    <>
      <ActivitiesWrapper {...props}>
        <main>
          <div className="tableCard">
            {/*  header start */}
            <MainHeader
              button
              buttonText="Add Activity Type"
              link="/activity-type/add"
              title="Activity Types"
              icon={<FaPlus />}
              iconMarginRight={5}
            />
            {/* end of header */}

            {/* table start */}
            {!isLoading ? (
              <ActivitiesTypeTable
                activityTypes={activityTypes}
                goToUpdateActivityTypeScreen={gotToUpdateActivityType}
                goToDeleteActivityTypeScreen={showDeleteActivityTypeModal}
              />
            ) : (
              <TableLoading rows={20} cols={3} header={false} />
            )}
            {/* table end  */}
          </div>
        </main>
        {isActionLoading && <FullPageLoader visible={isActionLoading} />}
      </ActivitiesWrapper>

      <Dialog
        visible={activityTypeModalVisibility}
        style={{ width: "32rem", zIndex: 999999 }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={activityModalFooter}
        onHide={hideActivityModal}
      >
        <div
          className="confirmation-content"
          style={{ marginTop: 20, display: "flex", alignItems: "center" }}
        >
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem", marginRight: 15, color: "#e65061" }}
          />
          {
            <span>
              Are you sure you want to{" "}
              {modalType === "update" ? (
                !empty(selectedActivityTypeDetail) &&
                !empty(selectedActivityTypeDetail.active) &&
                selectedActivityTypeDetail.active ? (
                  <span style={{ color: "red" }}>
                    <strong>disable</strong>
                  </span>
                ) : (
                  <span style={{ color: "green" }}>
                    <strong>enable</strong>
                  </span>
                )
              ) : (
                <span style={{ color: "red" }}>
                  <strong>delete</strong>
                </span>
              )}{" "}
              the selected activity type -{" "}
              <strong>
                {!empty(selectedActivityTypeDetail) &&
                !empty(selectedActivityTypeDetail.title)
                  ? selectedActivityTypeDetail.title
                  : ""}
              </strong>
              {selectedActivityTypeDetail && (
                <b>
                  {!empty(selectedActivityTypeDetail.name)
                    ? selectedActivityTypeDetail.name
                    : ""}
                </b>
              )}
              ?
            </span>
          }
        </div>
      </Dialog>
      <Toast ref={toastTR} style={{ zIndex: 99999 }} position="bottom-left" />
    </>
  );
};

export default ActivityTypes;
